import type z from 'zod/v4'
import { relations } from 'drizzle-orm'
import { pgTable, primaryKey, uuid } from 'drizzle-orm/pg-core'
import { createInsertSchema, createSelectSchema, createUpdateSchema } from 'drizzle-zod'

import { Book } from '../book/book'
import { LibraryHomepageRow } from './library-homepage-row'

export const LibraryHomepageRowToBook = pgTable(
  'library_homepage_row_to_book',
  {
    libraryHomepageRowId: uuid()
      .notNull()
      .references(() => LibraryHomepageRow.id, { onDelete: 'cascade' }),
    bookId: uuid()
      .notNull()
      .references(() => Book.id, { onDelete: 'cascade' }),
  },
  (table) => [
    primaryKey({
      columns: [table.libraryHomepageRowId, table.bookId],
      name: 'library_homepage_row_to_book_pk',
    }),
  ],
)

export const libraryHomepageRowToBookRelations = relations(LibraryHomepageRowToBook, ({ one }) => ({
  libraryHomepageRow: one(LibraryHomepageRow, {
    fields: [LibraryHomepageRowToBook.libraryHomepageRowId],
    references: [LibraryHomepageRow.id],
  }),
  book: one(Book, {
    fields: [LibraryHomepageRowToBook.bookId],
    references: [Book.id],
  }),
}))

export const InsertLibraryHomepageRowToBookSchema = createInsertSchema(LibraryHomepageRowToBook)
export const UpdateLibraryHomepageRowToBookSchema = createUpdateSchema(LibraryHomepageRowToBook).partial()
export const SelectLibraryHomepageRowToBookSchema = createSelectSchema(LibraryHomepageRowToBook)

export type InsertLibraryHomepageRowToBook = typeof LibraryHomepageRowToBook.$inferInsert
export type UpdateLibraryHomepageRowToBook = z.infer<typeof UpdateLibraryHomepageRowToBookSchema>
export type SelectLibraryHomepageRowToBook = typeof LibraryHomepageRowToBook.$inferSelect
